import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          Soy un <span className="purple">apasionado de la tecnología y la programación</span> , 
          lo cual me llevó a adentrarme en este mundo que tanto disfruto. Actualmente resido en <span className="purple"> CABA </span> 
          y me considero una persona con una gran <span className="purple">capacidad para adaptarme rápidamente </span>a nuevos entornos y desafíos.
          <br />
          <br />
          Me encanta <span className="purple"> trabajar en equipo.</span>, ya que creo firmemente que la colaboración nos permite crecer tanto a nivel personal como profesional. Valoro la <span className="purple">iniciativa </span>y la <span className="purple"> escucha activa</span> como herramientas esenciales para construir relaciones sólidas y productivas.
          <br />
          <br />
          Además, tengo un deseo constante de <span className="purple"> aprender y mejorar cada día</span>, lo que me motiva a enfrentar nuevos retos con entusiasmo y a seguir desarrollando mis<span className="purple"> habilidades</span> .
          <br />
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
